import { Fragment } from "react";
import "./CaseStudy.scss";
import CaseStudyCard from "./casestudycard/CaseStudyCard";
import ArrowBtn from "../../../components/arrowbtn/ArrowBtn";

const CaseStudy = ({ title, data, tag, btnTitle, btnClick }) => {
  return (
    <section className="case_study">
      <div className="content_wrap p_top p_bottom">
        <h2 className="wow fadeInUp">{title}</h2>

        {data?.length > 0 ? (
          <div className="cards_grid">
            {data?.slice(0, 3)?.map((ele, k) => {
              return (
                <Fragment key={ele._id}>
                  <CaseStudyCard
                    img={ele.image}
                    title={ele?.name}
                    text={ele?.small_description}
                    k={k}
                    tag={tag}
                    slug={ele?.slug}
                  />
                </Fragment>
              );
            })}
          </div>
        ) : (
          <p className="text-center mt-5">Data not found...</p>
        )}

        <div className="center_btn_wrap">
          <ArrowBtn
            text={btnTitle}
            theme="white_secondary"
            handleClick={btnClick}
            classList="wow fadeInUp"
          />
        </div>
      </div>
    </section>
  );
};

export default CaseStudy;
